<template>
    <div class="installt">
        <div class="intext">商品管理列表</div>
        <div class="addpopers">
            <!-- <div class="addpoper" @click="openDialog">
                <div> <el-icon :size="24" color="#fff">
                        <Plus style=" margin-right: 8px" />
                    </el-icon></div>
                <div style="height: 24px;">批量上架</div>

            </div> -->
            <div class="addpoper" @click="goodadd">
                <div> <el-icon :size="24" color="#fff">
                        <Plus style=" margin-right: 8px" />
                    </el-icon></div>
                <div style="height: 24px;">添加商品</div>

            </div>
        </div>

    </div>
    <div class="goodsort">
        <div class="goodlei">
            <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
                <el-tab-pane :label="'助花联盟商品（'+totallists+'件）'" name="first">
                    <GoodList @totallist="totallist"></GoodList>
                </el-tab-pane>
                <el-tab-pane label="助花待审核商品" name="second">
                    <MerchLList></MerchLList>
                </el-tab-pane>
                <el-tab-pane label="积分商品" name="third">
                    <PointsList></PointsList>
                </el-tab-pane>
                <el-tab-pane label="零元购商品" name="fourth">
                    <ZeroGood></ZeroGood>
                </el-tab-pane>
            </el-tabs>
        </div>

    </div>
</template>

<script setup>
import GoodList from '@/components/GoodList.vue';
import MerchLList from '@/components/MerchLList.vue';
import PointsList from '@/components/PointsList.vue';
import ZeroGood from '@/components/ZeroGood.vue';
import { ref, onMounted } from 'vue'
import api from '@/api/api'
import { useRouter } from 'vue-router';
const router = useRouter()
const activeName = ref('first')
let totallists = ref(0)
const totallist = (val)=>{
    // console.log('totallist',val)
    totallists.value = val
}
const handleClick = (tab, event) => {
    console.log(tab, event)
}
//助花商品列表
let goodslist = ref([])
let wordKey = ref('')
const goodadd = () => {
    router.push('/home/goodlist/Category')
}

onMounted(() => {

})
</script>

<style lang="scss" scoped>
::v-deep .el-input {
    width: 168px;
    height: 48px;
    font-size: 16px;
    --el-input-text-color: #718096;
    --el-input-border-color: transparent;

    .el-input__wrapper {
        background: #F8F8F8 !important;

        .el-icon {
            width: 26px;
            height: 26px;

            svg {
                width: 26px;
                height: 26px;
            }
        }
    }

}

.installt {
    display: flex;
    height: 50px;
    justify-content: space-between;
    align-items: center;

    .intext {
        font-size: 32px;
        font-weight: 400;
        color: #0A1629;
    }

    .addpopers {
        display: flex;

        .addpoper {
            width: 132px;
            height: 48px;
            background: rgba(63, 140, 255);
            box-shadow: 0px 6px 12px 0px rgba(63, 140, 255, 0.26);
            border-radius: 8px;
            color: #FFFFFF;

            padding-left: 16px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            margin-left: 33px;
        }
    }

}

.goodsort {
    position: relative;
    margin-top: 22px;
    height: calc(100% - 50px - 32px);
    background-color: #fff;
    border-radius: 8px;

    .goodlei {
        height: 100%;
    }


}

::v-deep .demo-tabs {
    height: 100%;

    .el-tabs__header {
        margin-bottom: 0;
    }

    .el-tabs__content {
        height: calc(100% - 60px);
    }

    .el-tabs__nav-scroll {

        .el-tabs__nav {

            .el-tabs__item {
                height: 60px !important;
                margin-right: 61px;
            }
        }
    }

    #tab-first {
        margin-left: 24px !important;
    }
}

</style>